<template>
    <div style=" min-height: 800px; width: 100%; " class="body.special-body">
        <div class="container" style="">
            <div class="row">
                <div class="col-2">
                </div>
                <div class="col-8">
                    <div class="ueditor" style="margin-top: 30px; font-size: 15px; color: #666666;">
                        <span class="hover" @click="goback">返回上一页</span> / 当前题解
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-2" style="margin-top: 15px;">
                    <div style="float: right;">
                        <div><i @click="Up" class="el-icon-caret-top hh" :style="upobj"></i></div>
                        <div style="font-size: 20px; text-align: center; color: #AFAFAF;" >{{ goods }}</div>
                        <div><i @click="Down" class="el-icon-caret-bottom hh" :style="downobj"></i></div>
                    </div><!-- #FF8C00 -->
                </div>
                <div class="col-8" style="margin-top: 15px; background-color: white; height: auto; padding: 20px;">
                    <!-- 这里放头像 名字 -->
                    <div>
                        <div>
                            <span style="font-size:25px;">{{ title }}</span>
                            <el-popconfirm
                                style="float: right; margin-left: 10px;"
                                @confirm="ClickMeToDelete"
                                confirm-button-text='确认删除'
                                cancel-button-text='取消'
                                icon="el-icon-info"
                                icon-color="red"
                                title="确定删除当前题解吗？"
                            >
                            <el-button slot="reference" v-show="isme" icon="el-icon-delete" type="danger" circle></el-button>
                            </el-popconfirm>

                            <el-button v-show="isme" @click="ClickMeToUpdate" style="float: right;" icon="el-icon-edit" type="primary" circle></el-button>
                        </div>
                        <br>
                        <el-link href="" :underline="false">
                            <img :src="photo" alt="" width="60px" height="60px" style="border-radius: 50%;">
                        </el-link>
                        <el-link href="" :underline="false">
                            <span class="name">{{ this.name }}</span>
                        </el-link>
                        <span style="float: right; font-size: 14px; color: #9FA19F; margin-top: 20px;">发表于 {{ this.createtime }}</span>
                    </div>
                    <el-divider></el-divider>
                    <div class="ueditor" >
                        <mavon-editor class="markdown-body" style="padding: 20px; z-index: 1;" codeStyle="monokai" v-html="content"></mavon-editor>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
</template>

<script>
    import $ from 'jquery'
    
    export default {
        name:'ShowNotes',
        data() {
            return {
                id:'',
                pbid:'',
                title:'',
                markdown:'',
                content:'',
                createtime:'',
                userid:'',
                name:'',
                photo:'',
                goods:0,
                isme:false,
                isLike:0, // 是否点过赞 1点过赞 0没有状态 -1点过踩
                upobj: {
                    "font-size": "40px", 
                    "color": "#AFAFAF",
                },
                downobj: {
                    "font-size": "40px", 
                    "color": "#AFAFAF",
                }
            }
        },
        methods: {
            goback() {
                const store = this.$store
                this.$router.push({
                    name:'Problem',
                    params: {
                        id: store.state.problem.notes.pbid
                    }
                })
            },
            getIsLike() { // 看看是不是点过赞了
                const vue = this
                const store = this.$store
                const route = this.$route
                console.log("notesid: ", route.params.id)
                console.log("userid: ", store.state.me.id)
                $.ajax({
                    url: 'https://app6132.acapp.acwing.com.cn/api/notes/like/get/',
                    type: "post",
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        notesid: route.params.id,
                        userid: store.state.me.id,
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            // console.log("查看点赞状态成功咯")
                            if (parseInt(resp.status) === 1) vue.upobj.color = "#FF8C00", vue.isLike = 1
                            else if (parseInt(resp.status) === -1) vue.downobj.color = "#FF8C00", vue.isLike = -1
                            else {
                                vue.upobj = {
                                    "font-size": "40px", 
                                    "color": "#AFAFAF",
                                }
                                vue.downobj = {
                                    "font-size": "40px", 
                                    "color": "#AFAFAF",
                                }
                                vue.isLike = 0;
                            }
                            console.log("isLike == >", vue.isLike)
                        } else {
                            console.log("查看点赞状态失败了，原因是 ==> ", resp.error_message)
                        }
                    },
                    error(resp) {
                        console.log("查看点赞状态彻底失败了， resp ==> ", resp)
                    }
                })
            },
            Up() { // 点赞
                if (this.isLike === 1) return 
                const status = 1;
                const route = this.$route
                const store = this.$store
                const vue = this

                $.ajax({
                    url: 'https://app6132.acapp.acwing.com.cn/api/notes/like/',
                    type: "post",
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        notesid: route.params.id, // 传入题解id
                        userid: store.state.me.id, // 传入当前用户id
                        status: status,
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            // console.log("点赞成功咯")
                            // console.log("status == >", resp.status)
                            if (parseInt(resp.status) === 1) {
                                vue.upobj.color = "#FF8C00"
                                vue.downobj.color = "#AFAFAF"
                                vue.isLike = 1
                            }
                            else if (parseInt(resp.status) === -1) {
                                vue.upobj.color = "#AFAFAF"
                                vue.downobj.color = "#FF8C00"
                                vue.isLike = -1
                            } else {
                                vue.upobj.color = vue.downobj.color = "#AFAFAF"
                                vue.isLike = 0;
                            }
                            vue.goods = resp.goods
                        } else {
                            console.log("点赞失败了，原因是 ==> ", resp.error_message)
                        }
                    },
                    error(resp) {
                        console.log("点赞彻底失败了， resp ==> ", resp)
                    }
                })
            },
            Down() { // 踩
                if (this.isLike === -1) return 
                const status = -1;
                const route = this.$route
                const store = this.$store
                const vue = this

                $.ajax({
                    url: 'https://app6132.acapp.acwing.com.cn/api/notes/like/',
                    type: "post",
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        notesid: route.params.id, // 传入题解id
                        userid: store.state.me.id, // 传入当前用户id
                        status: status,
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            // console.log("踩成功咯")
                            // console.log("status == >", resp.status)
                            if (parseInt(resp.status) === 1) {
                                vue.upobj.color = "#FF8C00"
                                vue.downobj.color = "#AFAFAF"
                                vue.isLike = 1
                            }
                            else if (parseInt(resp.status) === -1) {
                                vue.upobj.color = "#AFAFAF"
                                vue.downobj.color = "#FF8C00"
                                vue.isLike = -1
                            } else {
                                vue.upobj.color = vue.downobj.color = "#AFAFAF"
                                vue.isLike = 0
                            }
                            vue.goods = resp.goods
                        } else {
                            console.log("踩失败了，原因是 ==> ", resp.error_message)
                        }
                    },
                    error(resp) {
                        console.log("踩彻底失败了， resp ==> ", resp)
                    }
                })
            },
            ClickMeToUpdate() { // 修改自己的题解
                this.$router.push({
                    name:'UpdateNotes',
                    params: {
                        id: this.$route.params.id,
                    }
                })
            },
            ClickMeToDelete() { // 删除自己的题解
                const vue = this
                const store = this.$store
                const route = this.$route
                const router = this.$router

                $.ajax({
                    url: 'https://app6132.acapp.acwing.com.cn/api/notes/delete/',
                    type: "post",
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: route.params.id,
                        userid: vue.userid,
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            console.log("删除题解成功咯")
                            router.push({
                                name:'Problem',
                                params: {
                                    id: store.state.problem.notes.pbid
                                }
                            })
                        } else {
                            console.log("删除题解失败了，原因是 ==> ", resp.error_message)
                        }
                    },
                    error(resp) {
                        console.log("删除题解彻底失败了， resp ==> ", resp)
                    }
                })
            },
        },
        created() {
            console.log("params == > ", this.$route.params)
            
            const vue = this
            const store = this.$store
            const route = this.$route
            this.id = route.params.id

            $.ajax({
                url: 'https://app6132.acapp.acwing.com.cn/api/notes/getone/',
                type: "post",
                data: {
                    id: route.params.id
                },
                success(resp) {
                    if (resp.error_message === 'success') {
                        console.log("获取单个题目题解信息成功咯")
                        const one = JSON.parse(resp.one)
                        console.log("one == > ", one)
                        vue.pbid = one.pbid
                        vue.title = one.title
                        vue.markdown = one.markdown
                        vue.content = one.content
                        vue.createtime = one.createtime
                        vue.userid = parseInt(one.userid)
                        vue.name = one.name
                        vue.photo = one.photo
                        vue.goods = parseInt(one.goods)

                        vue.getIsLike() // 查询状态

                        store.commit("problem/UPDATENOTES", {
                            id : route.params.id,
                            pbid : one.pbid,
                            title : one.title,
                            markdown : one.markdown,
                            content : one.content,
                            createtime : one.createtime,
                            userid : parseInt(one.userid),
                            name : one.name,
                            photo : one.photo,
                            goods : parseInt(one.goods),
                        })

                        if (vue.userid == store.state.me.id) {
                            vue.isme = true
                        }
                    } else {
                        console.log("获取单个题目题解信息失败了，原因是 ==> ", resp.error_message)
                    }
                },
                error(resp) {
                    console.log("获取单个题目题解信息彻底失败了， resp ==> ", resp)
                }
            })

        },
        mounted() {
            document.body.style.backgroundColor = '#EEEEEE'; // 修改当前页面的 body 背景色
        },
        beforeDestroy() {
            document.body.style.backgroundColor = ''; // 页面销毁时恢复默认背景色
        }
    }
</script>

<style scoped>
.hh:hover{
    cursor: pointer;
}
.hover {
    color: #666666;
    text-decoration: none;
}
.hover:hover {
    color: #25C0BE;
}
.name {
    margin-left: 10px; 
    font-size: 16px; 
    color:#FC7123; 
    text-decoration: none;
}
/* .name:hover {
    text-decoration: none;
} */
</style>